export default {
  install(Vue, options = {}) {
    Vue.mixin({
      data: () => { return { DEBUG: false} },
      mounted() {
        if (Object.keys(options).length !== 0) {
          this.DEBUG = options.DEBUG;
        }
      }
    })
  }
}



// WEBPACK FOOTER //
// ./src/plugins/OlEnv.js